import { combineReducers } from 'redux';

// Import reducers
import table from './packet_visibility_table_reducer';
import form from './packet_visibility_form_reducer';

export default combineReducers({ table, form });
